import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

const useStyles = makeStyles((theme: Theme) => {
  return {
    normalCellOverride: {
      backgroundColor: theme.palette.common.accentLightblue,
    },
    shadedCellOverride: {
      backgroundColor: theme.palette.background.default,
    },
  };
});

const TimeTableCell = ({ ...props }: MonthView.TimeTableCellProps) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { isShaded } = props;
  return (
    <MonthView.TimeTableCell
      {...props}
      className={
        isShaded ? classes.shadedCellOverride : classes.normalCellOverride
      }
      style={{
        width: isMobile ? '150px' : 'auto',
      }}
    />
  );
};

export default TimeTableCell;
